import {AbstractControl, ValidatorFn} from '@angular/forms';

import {ArrayEveryValidatorKey} from './custom-validator-keys';

export function ArrayEveryValidator(array: (number | string)[]): ValidatorFn {
    return (control: AbstractControl): { [ArrayEveryValidatorKey]: boolean } | null => {
        if (control.value && Array.isArray(control.value)) {
            return (control.value.every((item: number | string) => array.indexOf(item) >= 0)) ? null :
                {[ArrayEveryValidatorKey]: true};
        }

        return null;
    };
}
